import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch sources with optional filters and pagination
export const getSources = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Source/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sources:", error);
    throw error;
  }
};

// API to insert or update a source
export const saveSource = async (sourceData) => {
  const response = await axios.post(`${BASE_URL}/api/Source/save`, sourceData, {
    headers: getAuthHeader(),
  });
  return response.data;
};



